import React, { FC, ReactNode } from 'react';

import { Box, Container, Grid, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';

interface CardWithIconProps {
  cardList: Array<{
    title: string;
    description: string;
    svg: ReactNode;
  }>;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      marginTop: theme.spacing(22),
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(10.3),
      },
    },
    gridItem: {
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(4.6),
      },
    },
    title: {
      color: 'rgba(69, 55, 55, 1)',
      fontWeight: 700,
      fontSize: 30,
      marginBottom: theme.spacing(5.3),
    },
    description: {
      color: 'rgba(69, 55, 55, 1)',
      fontWeight: 500,
      fontSize: 16,
      lineHeight: '32px',
    },
    divider: {
      width: '100%',
      height: 16,
      backgroundColor: theme.palette.primary.main,
      margin: theme.spacing(4, 0),
    },
  });
});

const CardWithIcon: FC<CardWithIconProps> = (props) => {
  const { cardList } = props;
  const classes = useStyles();

  return (
    <Container fixed>
      <Grid direction="row" container spacing={6} className={classes.root} data-aos="fade-up" data-aos-delay="400">
        {cardList.map((card) => {
          return (
            <Grid sm={12} md={4} className={classes.gridItem} item key={card.title}>
              {card.svg}
              <Box className={classes.divider} />
              <Typography className={classes.title}>{card.title}</Typography>
              <Typography className={classes.description}>{card.description}</Typography>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

export default CardWithIcon;
